import React from 'react';
import { Box } from '@mui/material';

const ParticlesBackground = () => {
  // Créer 80 particules avec des positions et animations aléatoires (plus nombreuses et plus visibles)
  const particles = Array.from({ length: 80 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    top: Math.random() * 100,
    size: Math.random() * 6 + 3,
    duration: Math.random() * 20 + 10,
    delay: Math.random() * 5
  }));

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#000',
        overflow: 'hidden',
        zIndex: 0,
        pointerEvents: 'none'
      }}
    >
      {/* Particules dorées */}
      {particles.map((particle) => (
        <Box
          key={particle.id}
          sx={{
            position: 'absolute',
            left: `${particle.left}%`,
            top: `${particle.top}%`,
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            backgroundColor: '#d4af37',
            borderRadius: '50%',
            opacity: 0.6,
            animation: `float ${particle.duration}s ease-in-out infinite`,
            animationDelay: `${particle.delay}s`,
            boxShadow: `0 0 ${particle.size * 4}px rgba(212, 175, 55, 0.8), 0 0 ${particle.size * 2}px rgba(212, 175, 55, 1)`,
            '@keyframes float': {
              '0%, 100%': {
                transform: 'translate(0, 0)',
                opacity: 0.6
              },
              '50%': {
                transform: `translate(${Math.random() * 50 - 25}px, ${Math.random() * 50 - 25}px)`,
                opacity: 1
              }
            }
          }}
        />
      ))}

      {/* Lignes de connexion subtiles */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          background: `
            linear-gradient(90deg, transparent 0%, rgba(212, 175, 55, 0.03) 50%, transparent 100%),
            linear-gradient(0deg, transparent 0%, rgba(212, 175, 55, 0.03) 50%, transparent 100%)
          `,
          backgroundSize: '100px 100px',
          opacity: 0.3
        }}
      />

      {/* Effet de grille subtil */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundImage: `
            repeating-linear-gradient(
              0deg,
              transparent,
              transparent 50px,
              rgba(212, 175, 55, 0.02) 50px,
              rgba(212, 175, 55, 0.02) 51px
            ),
            repeating-linear-gradient(
              90deg,
              transparent,
              transparent 50px,
              rgba(212, 175, 55, 0.02) 50px,
              rgba(212, 175, 55, 0.02) 51px
            )
          `
        }}
      />

      {/* Gradient radial au centre */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          height: '80%',
          background: 'radial-gradient(circle, rgba(212, 175, 55, 0.05) 0%, transparent 70%)',
          pointerEvents: 'none'
        }}
      />
    </Box>
  );
};

export default ParticlesBackground;
